export default __webpack_public_path__ + "static/media/smartlock.dc30ec89.svg";